module.exports = __webpack_public_path__ + "img/home_ic1.3f089cf1.jpg";